namespace GeniuzPOS.Lookups {
    export namespace LookupBrandService {
        export const baseUrl = 'Lookups/LookupBrand';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupBrandRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Lookups/LookupBrand/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>LookupBrandService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
